import { getField, updateField } from 'vuex-map-fields'
import {
  findBeneficiarios,
  findDadosBeneficiarioFromChaveUnica,
  hasMultPerfil
} from '@mobilesaude/frontend_libs/helpers/usuario'
import moment from 'moment/moment'

// Initial state
const initialState = () => ({
  token: null,
  loading: false,
  chavePasse: null,
  usuarioPayload: {}
})

// root state object.
// each Vuex instance is just a single state tree.
const state = initialState

// getters are functions
const getters = {
  getField,
  token: state => state.token,
  isLogin: state => !!state.token,
  chavePasse: state => state.chavePasse,
  user: state => (state.usuarioPayload || {}).usuarioLogado || {},
  chaveUnica: state => ((state.usuarioPayload || {}).usuarioLogado || {}).chaveUnica,
  contratos: state => (state.usuarioPayload || {}).contratos || [],
  beneficiarios: state => findBeneficiarios(state.usuarioPayload),
  agenteRelacionamento: state => (state.usuarioPayload || {}).agenteRelacionamento || {},
  dadosUsuarioLogado: state => {
    if (!state.usuarioPayload.usuarioLogado || Object.keys(state.usuarioPayload.usuarioLogado).length === 0) {
      return null
    }

    const beneficiario = findDadosBeneficiarioFromChaveUnica(
      state.usuarioPayload.usuarioLogado.chaveUnica,
      findBeneficiarios(state.usuarioPayload)
    )
    if (!beneficiario) {
      return { ...state.usuarioPayload.usuarioLogado }
    }

    return {
      ...state.usuarioPayload.usuarioLogado,
      dadosPessoais: {
        ...beneficiario.dadosPessoais
      }
    }
  },
  hasMultPerfil: state => hasMultPerfil(state.usuarioPayload),
  nomeUsuario: state => {
    if (hasMultPerfil(state.usuarioPayload)) {
      return state.usuarioPayload.usuarioLogado.nome
    }
    const beneficiario = findDadosBeneficiarioFromChaveUnica(
      state.usuarioPayload.usuarioLogado.chaveUnica,
      findBeneficiarios(state.usuarioPayload)
    )
    return beneficiario ? beneficiario.dadosPessoais.nome : ''
  },
  idadeUsuario: state => {
    let idade
    if (hasMultPerfil(state.usuarioPayload)) {
      idade = state.usuarioPayload.usuarioLogado.pessoaFisica.dataNascimento
    } else {
      const beneficiario = findDadosBeneficiarioFromChaveUnica(
        state.usuarioPayload.usuarioLogado.chaveUnica,
        findBeneficiarios(state.usuarioPayload)
      )
      idade = beneficiario ? beneficiario.dadosPessoais.dataNascimento : ''
    }
    return idade ? moment().diff(idade, 'years') + ' anos' : ''
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  initialize ({ commit }, payload) {
    commit('INITIALIZE_LOGIN', payload)
  },
  setLogin ({ commit }, payload) {
    commit('SET_LOGIN', payload)
  },
  setToken ({ commit }, payload) {
    commit('SET_TOKEN', payload)
  },
  setBeneficiario ({ commit }, payload) {
    commit('SET_BENEFICIARIO', payload)
  },
  setChavePasse ({ commit }, payload) {
    commit('SET_CHAVE_PASSE', payload)
  },
  initialState ({ commit }) {
    commit('INITIAL_STATE')
  }
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  updateField,
  INITIALIZE_LOGIN (state, payload) {
    state.token = payload.json.authorization
  },
  SET_LOGIN (state, payload) {
    state.usuarioPayload = payload.data
    state.token = state.usuarioPayload.token
    state.chavePasse = state.usuarioPayload.usuarioLogado.chavePasse
  },
  SET_BENEFICIARIO (state, payload) {
    state.usuarioPayload = payload.data ? payload.data : payload
    if (state.usuarioPayload.token) {
      state.token = state.usuarioPayload.token
    }
    state.chavePasse = state.usuarioPayload.usuarioLogado.chavePasse
  },
  SET_TOKEN (state, payload) {
    state.token = payload
  },
  SET_CHAVE_PASSE (state, payload) {
    state.chavePasse = payload
  },
  INITIAL_STATE (state) {
    const initial = initialState()
    Object.keys(initial).forEach(key => { state[key] = initial[key] })
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
